import { takeEvery, takeLatest } from "redux-saga/effects";
import * as sagas from "./sagas";
import * as types from "store/actions";

/**
 * When an Action is dispatched, the Watcher will tie a specific action to a
 * specific Saga.
 *
 * The Saga will call a service and place the response of that service into the
 * Redux store
 */

export function* watchUserAuthentication() {
  yield takeLatest(types.LOGIN_USER, sagas.loginSaga);
  yield takeLatest(types.LOGOUT_USER, sagas.logoutSaga);
  yield takeLatest(
    types.CREATE_PASSWORD_NOAUTH,
    sagas.createPasswordNoAuthSaga
  );
  yield takeLatest(types.RESET_PHONE, sagas.resetPhoneSaga);
  yield takeLatest(
    types.RESET_OPERATION_EMAIL_NOAUTH,
    sagas.resetOperationEmailNoAuthSaga
  );
}

export function* watchAuthyAuthentication() {
  yield takeLatest(types.REGISTER_AUTHY_USER, sagas.registerAuthyUserSaga);
  yield takeLatest(types.VERIFY_AUTHY_OTP, sagas.verifyAuthyOtpSaga);
  yield takeLatest(types.TEXT_AUTHY_OTP, sagas.textAuthyOtpSaga);
  yield takeLatest(types.CALL_AUTHY_OTP, sagas.callAuthyOtpSaga);
}

export function* watchJwt() {
  yield takeLatest(types.DECODE_JWT, sagas.decodeJwtSaga);
  yield takeLatest(types.REFRESH_JWT, sagas.refreshJwtSaga);
}

export function* watchAccount() {
  yield takeEvery(types.GET_ACCOUNT, sagas.getAccountSaga);
  yield takeEvery(types.GET_ACCOUNTS, sagas.getAccountsSaga);
  yield takeEvery(
    types.GET_CURRENT_USER_ACCOUNT_OWNER,
    sagas.getCurrentUserAccountOwnerSaga
  );
  yield takeLatest(types.ADD_ACCOUNT, sagas.addAccountSaga);
  yield takeLatest(types.MODIFY_ACCOUNT, sagas.modifyAccountSaga);
  yield takeLatest(types.DELETE_ACCOUNT, sagas.deleteAccountSaga);
}

export function* watchAccountUser() {
  yield takeEvery(types.GET_ACCOUNT_USERS, sagas.getAccountUsersSaga);
  yield takeLatest(types.ADD_ACCOUNT_USER, sagas.addAccountUserSaga);
  yield takeLatest(types.DELETE_ACCOUNT_USER, sagas.deleteAccountUserSaga);
}

export function* watchAnalysis() {
  yield takeEvery(types.GET_ANALYSIS, sagas.getAnalysisSaga);
  yield takeEvery(types.GET_ANALYSES, sagas.getAnalysesSaga);
  yield takeLatest(types.GET_ANALYSIS_TEAMS, sagas.getAnalysisTeamsSaga);
  yield takeLatest(types.ADD_ANALYSIS, sagas.addAnalysisSaga);
  yield takeLatest(types.ADD_ANALYSIS_TEAM, sagas.addAnalysisTeamSaga);
  yield takeLatest(types.MODIFY_ANALYSIS, sagas.modifyAnalysisSaga);
  yield takeLatest(types.DELETE_ANALYSIS, sagas.deleteAnalysisSaga);
  yield takeLatest(types.DELETE_ANALYSIS_TEAM, sagas.deleteAnalysisTeamSaga);
}

export function* watchUser() {
  yield takeEvery(types.GET_USER, sagas.getUsersSaga);
  yield takeEvery(types.GET_USERS, sagas.getUsersSaga);
  yield takeLatest(types.ADD_USER, sagas.addUserSaga);
  yield takeLatest(types.MODIFY_USER, sagas.modifyUserSaga);
  yield takeLatest(types.DELETE_USER, sagas.deleteUserSaga);
  yield takeLatest(types.GET_CURRENT_USER, sagas.getCurrentUserSaga);
  yield takeLatest(
    types.CHANGE_PASSWORD_CURRENT_USER,
    sagas.changePasswordCurrentUserSaga
  );
}

export function* watchTeam() {
  yield takeEvery(types.GET_TEAM, sagas.getTeamSaga);
  yield takeEvery(types.GET_TEAMS, sagas.getTeamsSaga);
  yield takeLatest(types.ADD_TEAM, sagas.addTeamSaga);
  yield takeLatest(types.MODIFY_TEAM, sagas.modifyTeamSaga);
  yield takeLatest(types.DELETE_TEAM, sagas.deleteTeamSaga);
}

export function* watchTeamUser() {
  yield takeEvery(types.GET_TEAM_USERS, sagas.getTeamUsersSaga);
  yield takeLatest(types.ADD_TEAM_USER, sagas.addTeamUserSaga);
  yield takeLatest(types.DELETE_TEAM_USER, sagas.deleteTeamUserSaga);
}

export function* watchRole() {
  yield takeEvery(types.GET_ROLES, sagas.getRolesSaga);
}

export function* watchPermission() {
  yield takeEvery(types.GET_PERMISSIONS, sagas.getPermissionsSaga);
}

export function* watchRolePermission() {
  yield takeEvery(types.GET_ROLEPERMISSIONS, sagas.getRolePermissionsSaga);
}

export function* watchConfig() {
  yield takeEvery(types.GET_CONFIG, sagas.getConfigSaga);
  yield takeEvery(types.GET_CONFIGS, sagas.getConfigsSaga);
  yield takeLatest(types.ADD_CONFIG_KEY, sagas.addConfigKeySaga);
  yield takeLatest(types.MODIFY_CONFIG_KEY, sagas.modifyConfigKeySaga);
  yield takeLatest(types.DELETE_CONFIG_KEY, sagas.deleteConfigKeySaga);
}

export function* watchConfigDefault() {
  yield takeEvery(types.GET_CONFIG_DEFAULT, sagas.getConfigDefaultSaga);
}

export function* watchExternalLink() {
  yield takeEvery(types.GET_EXTERNAL_LINK, sagas.getExternalLinkSaga);
  yield takeEvery(types.GET_EXTERNAL_LINKS, sagas.getExternalLinksSaga);
  yield takeLatest(types.ADD_EXTERNAL_LINK, sagas.addExternalLinkSaga);
  yield takeLatest(types.MODIFY_EXTERNAL_LINK, sagas.modifyExternalLinkSaga);
  yield takeLatest(types.DELETE_EXTERNAL_LINK, sagas.deleteExternalLinkSaga);
}

export function* watchAboutMicroservice() {
  yield takeEvery(types.GET_ABOUT_MICROSERVICE, sagas.getAboutMicroserviceSaga);
  yield takeEvery(
    types.GET_ABOUT_MICROSERVICES,
    sagas.getAboutMicroservicesSaga
  );
  yield takeLatest(
    types.ADD_ABOUT_MICROSERVICE,
    sagas.addAboutMicroserviceSaga
  );
  yield takeLatest(
    types.MODIFY_ABOUT_MICROSERVICE,
    sagas.modifyAboutMicroserviceSaga
  );
  yield takeLatest(
    types.DELETE_ABOUT_MICROSERVICE,
    sagas.deleteAboutMicroserviceSaga
  );
}

export function* watchAlert() {
  yield takeEvery(types.GET_ALERTS, sagas.getAlertsSaga);
}

export function* watchGlobalMessage() {
  yield takeEvery(types.SET_GLOBAL_MESSAGE, sagas.setGlobalMessageSaga);
}

export function* watchKibana() {
  yield takeEvery(types.KIBANA_LOGIN, sagas.kibanaLoginSaga);
}

export function* watchLogstash() {
  yield takeEvery(types.GET_LOGSTASH_PIPELINES, sagas.getLogstashPipelinesSaga);
  yield takeEvery(
    types.GET_LOGSTASH_PIPELINE_STATS,
    sagas.getLogstashPipelineStatsSaga
  );
}

export function* watchYms() {
  yield takeEvery(
    types.YMS_DECKING_OPTIMIZATION_TESTER,
    sagas.ymsDeckingOptimizationTesterSaga
  );
  yield takeEvery(types.YMS_DECKING_FILTER, sagas.ymsDeckingFilterSaga);
}
